/* @flow strict */

import * as React from 'react';
import './stepToggler.scss';

type PropsType = {
  toggleStep: () => void,
  currentStep: number,
  eventDetail: {
    questions: []
  },
  isRegistrationShow: boolean
};

const StepToggler = (props: PropsType): React.Element<'div'> => {
  const { toggleStep, currentStep, eventDetail, isRegistrationShow } = props;
  const items = {
    1: 'Ticket info',
    2: 'Confirm purchase',
    3: 'Payment info',
    4: 'Registration info',
    5: 'Download tickets'
  };

  return (
    <div className="sparxo-checkout-StepToggler_container">
      <div>
        <div className="sparxo-checkout-StepToggler_stepToggler">
          {
            Object.entries(items).map((item: []): React.Element<'div'> => {
                if (+item[0] === 4 && !(!!_.size(eventDetail.questions))) return null;
                return (
                  <div
                    key={item[0]}
                    className={`
                      sparxo-checkout-StepToggler_stepItem
                      ${+item[0] === currentStep && 'sparxo-checkout-StepToggler_currentStep'}
                      ${+item[0] < currentStep && 'sparxo-checkout-StepToggler_activeStep'}
                      ${isRegistrationShow && 'sparxo-checkout-StepToggler_tinyStep'}
                    `}
                    onClick={(): void => toggleStep(+item[0])}
                  >
                    {item[1]}
                  </div>
                );
              }
            )
          }
        </div>
      </div>
    </div>
  );
};

export default StepToggler;
